import { render } from "./ComplianceConsultChat.vue?vue&type=template&id=5b047e87&scoped=true"
import script from "./ComplianceConsultChat.vue?vue&type=script&lang=js"
export * from "./ComplianceConsultChat.vue?vue&type=script&lang=js"

import "./ComplianceConsultChat.vue?vue&type=style&index=0&id=5b047e87&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b047e87"]])

export default __exports__